import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

/**
 * FOR-48 (BU-10) 10b — project "Show in client portal" toggle + phase-status
 * visibility. Proxies through graphql/ to the portal internal admin API.
 */
const mutation = graphql`
	mutation updateProjectPortalConfigMutation($input: UpdateProjectPortalConfigInput!) {
		updateProjectPortalConfig(input: $input) {
			projectPortalConfig {
				showInClientPortal
				portalPhaseStatusVisible
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return trackAndCommitMutation(environment, {mutation, variables, onCompleted: onSuccess, onError}, true);
}

export default {commit};
